import { useMapViewRoutingMetadata } from "contexts/RoutingMetadataContext";
import "./ScopeAssumptionsDialog.scss";

import { Dialog, DialogBody, DialogFooter } from "@blueprintjs/core";
import { segmentTrackDataFreshnessDialogClosed } from "analytics/analyticTrackEvents";
import useMapViewConfiguration from "contexts/MapViewConfigurationContext/hooks/useMapViewConfiguration";
import React from "react";
import ReactMarkdown from "react-markdown";
import { RegionType } from "types/regionType";
import {
    MISO_2022_REALISTIC_SCOPE_TYPE,
    Scope,
    ScopeName,
    WECC_LOAD_SCOPE_TYPE
} from "types/scope";
import DownloadQueueProjectsButton from "./queueProjects/DownloadQueueProjectsButton";

type ScopeAssumptionsDialogProps = {
    readonly isOpen: boolean;
    readonly closeDialog: () => void;
    readonly currentScope: Scope;
};

const ScopeAssumptionsDialog: React.FC<ScopeAssumptionsDialogProps> = (
    props
) => {
    const { isOpen, closeDialog, currentScope } = props;
    const { region: selectedRegion } = useMapViewRoutingMetadata();
    const {
        busFiltersConfiguration: {
            busFilters: { scope }
        }
    } = useMapViewConfiguration();

    const scopeAssumptionsMarkdown =
        currentScope.data_freshness_markdown ||
        "Scope assumptions information not available.";

    const hasDownloadQueueProjectsButton =
        hasDownloadQueueProjectsButtonBasedOnRegionAndScope(
            selectedRegion,
            scope
        );

    return (
        <Dialog
            isOpen={isOpen}
            title={"Scope assumptions"}
            onClose={() => {
                segmentTrackDataFreshnessDialogClosed(selectedRegion, scope);
                closeDialog();
            }}
            icon="time"
        >
            <DialogBody>
                <ReactMarkdown>{scopeAssumptionsMarkdown}</ReactMarkdown>
            </DialogBody>
            {hasDownloadQueueProjectsButton && (
                <DialogFooter
                    minimal={true}
                    actions={<DownloadQueueProjectsButton />}
                />
            )}
        </Dialog>
    );
};

const hasDownloadQueueProjectsButtonBasedOnRegionAndScope = (
    selectedRegion: RegionType,
    selectedScope: ScopeName
) => {
    if (
        selectedRegion === RegionType.MISO &&
        selectedScope === MISO_2022_REALISTIC_SCOPE_TYPE
    ) {
        return true;
    } else if (
        selectedRegion === RegionType.WECC &&
        selectedScope !== WECC_LOAD_SCOPE_TYPE
    ) {
        return true;
    } else {
        return false;
    }
};

export default ScopeAssumptionsDialog;
